/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminGetVideoOptions, AdminGetVideoResponses } from '../../models/AdminGetVideo'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Video
 * {@link /admin/video/:video_id}
 */
export function adminGetVideo<ThrowOnError extends boolean = true>(options: Options<AdminGetVideoOptions, ThrowOnError>): Promise<UnwrappedResult<AdminGetVideoResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/admin/video/{video_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminGetVideoResponses, ThrowOnError>>
}
